$traceurRuntime.ModuleStore.getAnonymousModule(function() {
  "use strict";
  angular.module('app.test', ['ngSanitize', 'ngResource', 'ngAnimate', 'ui.router', 'common.ui', 'common.backend', 'templates', 'angular-google-analytics']).config(function($stateProvider, $urlRouterProvider, $httpProvider, AnalyticsProvider) {
    var TestResolve = {testData: function($http, $q) {
        var myPromise = $q.defer();
        var content = (typeof TEST_JSON_API !== 'undefined' ? TEST_JSON_API : '/test/content.json');
        $http.get(content).then(function(response) {
          myPromise.resolve(response.data);
        });
        return myPromise.promise;
      }};
    $stateProvider.state('test', {
      title: 'Test',
      template: '<ui-view id="test" />',
      resolve: TestResolve,
      abstract: true
    }).state('test.start', {
      title: 'Test Start',
      url: '/',
      templateUrl: "test/start.html",
      resolve: TestResolve,
      controller: 'testCtrl'
    }).state('test.question', {
      title: 'Quiz',
      url: '/question/:question',
      templateUrl: "test/question.html",
      controller: 'testQuestionCtrl'
    }).state('test.results', {
      title: 'Test',
      url: '/results/:result',
      templateUrl: "test/results.html",
      controller: 'testResultsCtrl'
    });
    ;
    $urlRouterProvider.otherwise("/");
  }).run(function(AudioManager, $rootScope, Analytics) {
    AudioManager.load();
    $rootScope.page = {setTitle: function(title) {
        this.title = title + ' | Online Masters';
      }};
    $rootScope.$on('$stateChangeSuccess', (function(event, current, currentParams) {}));
  });
  ;
  return {};
});

